<template>
  <div class="mess">
    <div class="bubble_cont messSay" v-if="type==10" v-html="processedContent(content)"  @contextmenu.prevent  v-long-press="selectText" ></div>
    <div class="bubble_cont" v-if="type==17" v-html="content" ref="hirot"></div>
    <div class="img_cont" v-if="type==20" v-html="content" @click="seeImg(content)"></div>
    <div class="bubble_cont pro_cont" v-if="type==50" v-html="content" @click="went(50)"></div>
    <div class="bubble_cont order_cont" v-if="type==40" v-html="content" @click="went(40)"></div>
    <div class="robot" v-if="type==15" v-html="content" ref="robot"></div>
  </div>
</template> 
<script>
  import { showImagePreview } from 'vant';
  import wx from "weixin-js-sdk";
  import { sendType} from '@/assets/js/index'
  import { showToast } from 'vant';
  import { processedContent,useUniBridge } from '@/assets/js/index'
  import {
    useSocket
  } from "@/stores/index";

  function isWeapp() {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;

    const ua = navigator.userAgent;
    // 关键：必须处于微信浏览器环境（MicroMessenger）
    const isWechat = /MicroMessenger/i.test(ua);
    if (!isWechat) return false;

    // 1. 官方注入的环境变量（小程序 web-view 中同步可用）
    if (window.__wxjs_environment === 'miniprogram') return true;

    // 2. 微信 JS-SDK 中的 miniProgram 对象（存在说明已加载 jssdk 且在小程序环境）
    if (typeof wx !== 'undefined' && wx.miniProgram && typeof wx.miniProgram.getEnv === 'function') {
      return true;
    }

    // 3. UA 中明确包含 miniprogram（某些旧版本或特殊场景）
    if (/miniprogram/i.test(ua)) return true;

    return false;
  }
  function removeAllTags(str) {
    return str
        .replace(/<[^>]+>/g, '') 
        .replace(/&lt;.*?&gt;/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}

  export default {
    props: {
      type: Number,
      content: String,
      isHis: Boolean
    },
    data() {
      return {
        isSend: false
      }
    },
    mounted() {
      this.$nextTick(() => {
        const store = useSocket();
        if (this.type == sendType.MENU && !this.isHis) {
          let res = {
            content: '',
            groupId: store.group.id,
            type: sendType.TEXT
          };
          const robot = this.$refs.robot
          if (robot) {
            robot.addEventListener('click', async(event) => {
              const li = event.target.closest('li');
              if (li && !this.isSend) {
                this.isSend = true;
                const text = li.innerText;
                res.content = text;
                await store.sendMess(res);
                this.isSend = false;
              }
            });
          }
        }
        if(this.type==sendType.WAYLAY){
          const hirot = this.$refs.hirot;
          if (hirot) {
            hirot.addEventListener('click', async(event) => {
              const li = event.target.closest('a');
              if (li && !this.isSend) {
                this.isSend = true;
                let res = {
                  content:li.innerText,
                  groupId: store.group.id,
                  type:li.getAttribute('data-type') || sendType.TEXT
                };
                await store.sendMess(res)
                this.isSend = false;
              }
            });
          }
        }
      })
    },
    methods: {
      disableContextMenu(event){  
            //阻止文本选中后弹出功能菜单  
           //方式一：使用preventDefault()  
        event.preventDefault()  
           //方式二：修改returnValue  
        event.returnValue=false  
      },
      selectText(isLongPress, event) {  
        // touch.js 指令在短按时也会调用该函数并传入 false，只在长按 (true) 时执行复制
        if (!isLongPress) return
        const text = removeAllTags(event.target.innerHTML);  
        if(text){  
          const textarea = document.createElement('textarea');
          textarea.value = text;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'fixed';  // 避免移动端页面滚动
          textarea.style.left = '-9999px';
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
          showToast('复制成功');
        }  
      }, 
      processedContent:(val,size=20) => processedContent(val,size),
      ques() {
        const data = this.extractDataAttributes(this.content)
        console.log(data)
      },
      //orderNo goodsId  wxappId token code 详情
      extractDataAttributes(data) {
        const regexPatterns = {
          // skid: /data-skid='([^']*)'/,
          id: /data-id='([^']*)'/,
          type: /data-type='([^']*)'/,
          orderNo: /data-orderNo='([^']*)'/,
        }
        //const skidMatch = data.match(regexPatterns.skid);
        const idMatch = data.match(regexPatterns.id);
        const typeMatch = data.match(regexPatterns.type);
        const orderNo = data.match(regexPatterns.orderNo);
        return {
          // skid: skidMatch ? skidMatch[1] : null,
          id: idMatch ? idMatch[1] : null,
          type: typeMatch ? typeMatch[1] : null,
          orderNo: orderNo ? orderNo[1] : null
        };
      },
      went(type) {
        const data = this.extractDataAttributes(this.content);
        const { goToUniPage } = useUniBridge();

        if (data.type === 190) return;

        // 统一生成跳转地址
        const url = type === 40
          ? `/pages/order/detail?order_type=${data.type}&order_id=${data.id}`
          : `/pages/goods/index?goods_id=${data.id}`;

        console.log('222', isWeapp() );
        if (isWeapp() ) {
          wx.miniProgram.navigateTo({ url });
        } else {
          // iOS 或 Android 都使用同一方法
          goToUniPage(url);
        }
      },
      fData(data) {
        const nData = data.replace(/&lt;/g, "<").replace(/&gt;/g, "'>");
        return nData;
      },
      seeImg(data) {
        const srcRegex = /<img[^>]+src="([^">]+)"/;
        const regex = /data-url\s*=\s*["']([^"']+)["']/i;
        const playMatch = data.match(regex);
        const match = data.match(srcRegex);
        if(playMatch && playMatch[1]){
          useSocket().seeOP('player',playMatch[1])
        }
        if (match && match[1]) {
          showImagePreview({
            images: [match[1]],
            startPosition: 0
          });
        }
      }
    }
  }
</script>